import { object, string } from 'yup';
import { originSchema } from './origin.validator';
import { TFunction } from 'i18next';

export const addressSchema = () => {
    return object().shape({
        street: string().optional(),
        number: string().optional(),
        box: string().optional(),
        postalCode: string().optional(),
        city: string().optional(),
        country: string().optional(),
    });
};

export const addressWithCountrySchema = (t: TFunction) => {
    return object().shape({
        street: string().optional(),
        number: string().optional(),
        box: string().optional(),
        postalCode: string()
            .optional()
            .trim()
            .test(
                'Empty postal code or postal code existing of 4 characters',
                t('postalCodeIsInvalid'),
                (value) => !value || value.length === 4,
            ),
        city: string().optional(),
        country: originSchema().optional().nullable(),
    });
};
